// 定义域名分组
const domainGroups = {
  other: ['jpweb.bid.fans', 'esenmart.com','jpnbuy.com','www.jpnbuy.com'],
  xg: ['gsritao.com', 'www.gsritao.com','wakuwaku.bar', 'ripaigo.com', 'croxx.zzqss.com', 'wanshiwu.jp', 'renkongjian.zzqss.com'],
  xgTwo: ['jpxu.zzqss.com', 'jpware.com.hk', 'japan51buy.zzqss.com', 'meilu.jp', 'www.meilu.jp'],
  xgThree: ['gobuy.jp', 'yueyanggou.net', 'eshoppingtokyo.com', 'jp.moximoxijp.com', 'habigoujp.com', 'www.yueyanggou.net', 'jpweb.zzqss.com','japan51buy.com','ritaojpgo.com','buygo.zzqss.com','web.yueyanggou.net','zlwj.zzqss.com','okbuy.jp'],
  rijitong: ['rijitong.zzqss.com','rijitongadmin.com','momomr.com','www.momomr.com'],
  axrpwFour: ['axrpw.com','ezgojpc.com','www.ezgojpez.com','ezgojpez.com','gototoshop.com','yifanxing.shop','daikei-tenso.top','daipai.daikei-tenso.com','yattamall.com'],
  gobuy: ['gobuy.zzqss.com'],
  bidbuy: ['bidbuy.io','bidbuy.io/hk/','bidbuy.io/th/','bidbuy.io/my/'],
  habigou: ['jp.habigoujp.com','jphabigou.com','www.jphabigou.com'],
  habigouTwo: ['yrrcjg.com','www.yrrcjg.com'],
  jiale: ['jiale.zzqss.com'],
  riya: ['riya.xin','ritaopai.net','www.ritaopai.net','ritaopai.shop','www.ritaopai.shop','ksjd.zzqss.com','japan-buy.top','komabox.com','riben-ts.zzqss.com','www.riben-ts.com','riben-ts.com','auc.zzqss.com'],
  beijixing: ['beijixing.zzqss.com', 'beijixingbuy.com',],
  beijixingTwo: ['yifanxingbuy.com', 'www.yifanxingbuy.com',],
};

export default domainGroups
